'use client';

import React from 'react';
import dynamic from 'next/dynamic';
import HeroSection from './HeroSection';

// 👇 Import dinámico del widget para evitar SSR con Leaflet
const BuenosAiresChatWidget = dynamic(
  () => import('@/components/tourism/BuenosAiresChatWidget'),
  {
    ssr: false,
    loading: () => (
      <div data-component-id="src/app/landing-page/components/LandingPageInteractive.tsx:13:6" data-component-path="src/app/landing-page/components/LandingPageInteractive.tsx" data-component-line="13" data-component-file="LandingPageInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22fixed%20bottom-6%20right-6%20z-40%22%7D" className="fixed bottom-6 right-6 z-40">
        <div data-component-id="src/app/landing-page/components/LandingPageInteractive.tsx:14:8" data-component-path="src/app/landing-page/components/LandingPageInteractive.tsx" data-component-line="14" data-component-file="LandingPageInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22rounded-full%20bg-teal-600%20text-white%20px-4%20py-2%20text-xs%20shadow-lg%22%2C%22textContent%22%3A%22Cargando%20asistente%E2%80%A6%22%7D" className="rounded-full bg-teal-600 text-white px-4 py-2 text-xs shadow-lg">
          Cargando asistente…
        </div>
      </div>
    ),
  }
);

interface LandingPageInteractiveProps {
  className?: string;
}

const LandingPageInteractive: React.FC<LandingPageInteractiveProps> = ({
  className = '',
}) => {
  return (
    <div data-component-id="src/app/landing-page/components/LandingPageInteractive.tsx:30:4" data-component-path="src/app/landing-page/components/LandingPageInteractive.tsx" data-component-line="30" data-component-file="LandingPageInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D"
      className={`min-h-screen bg-cover bg-center bg-no-repeat ${className}`}
      style={{ backgroundImage: "url('/imagenes/fondo.jpg')" }}
    >
      <main data-component-id="src/app/landing-page/components/LandingPageInteractive.tsx:34:6" data-component-path="src/app/landing-page/components/LandingPageInteractive.tsx" data-component-line="34" data-component-file="LandingPageInteractive.tsx" data-component-name="main" data-component-content="%7B%22elementName%22%3A%22main%22%7D">
        {/* Hero Section */}
        <HeroSection data-component-id="src/app/landing-page/components/LandingPageInteractive.tsx:36:8" data-component-path="src/app/landing-page/components/LandingPageInteractive.tsx" data-component-line="36" data-component-file="LandingPageInteractive.tsx" data-component-name="HeroSection" data-component-content="%7B%22elementName%22%3A%22HeroSection%22%7D" />

        {/*
          Si más adelante querés volver a activar secciones, las agregamos acá:
          <ThingsToDoGrid />
          <BestTimeToVisit />
          <AccommodationGuide />
          <InteractiveMap />
          <VisualGallery />
          <SocialProofSection />
          <CTASection />
        */}
      </main>

      {/* Buenos Aires AI Chat Widget (solo en cliente) */}
      <BuenosAiresChatWidget data-component-id="src/app/landing-page/components/LandingPageInteractive.tsx:51:6" data-component-path="src/app/landing-page/components/LandingPageInteractive.tsx" data-component-line="51" data-component-file="LandingPageInteractive.tsx" data-component-name="BuenosAiresChatWidget" data-component-content="%7B%22elementName%22%3A%22BuenosAiresChatWidget%22%7D" />
    </div>
  );
};

export default LandingPageInteractive;
